import React from 'react';
import {
  Button,
  Typography,
  Box,
  useMediaQuery,
} from '@material-ui/core';
import {
  Meridiem,
} from '../Calendar';
import { Day as DayType } from '../Calendar';
import theme, { BORDERS, COLORS, ROUNDED } from '../../../styles/theme';
import { Timeslot } from '../../../api/BookingCalendar';

interface DayProps {
  selectedTimeIndex?: number;
  selectedMeridiem?: Meridiem;
  selectedDayIndex?: number;
  currentDayIndex: number;
  selectedDay?: DayType;
  selectedTimeSlot?: Timeslot;
  day: DayType;
  changeTimeslot: ({
    day,
    meridiem,
    timeIndex,
  }: {
    day: DayType;
    meridiem?: Meridiem;
    timeIndex?: number;
  }) => void;
}

export default function MonthlyCalendarDay({
  selectedTimeIndex,
  selectedMeridiem,
  selectedDayIndex,
  currentDayIndex,
  changeTimeslot,
  selectedTimeSlot,
  day,
}: DayProps) {

  const meridies = Object.keys(day.timeslots) as Meridiem[];
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const calendarCellHeight = theme.spacing(4);
  const mobileCalendarCellHeight = theme.spacing(5);
  const parseTime = (time: string) => time.replace(/\s+/g, '');
  const timeSlotDate = selectedTimeSlot?.date;
  return (
    <Box display="flex" flexDirection="row" justifyContent={isMobile ? 'center' : ''} gridGap={isMobile ? 17 : 24} mt={3}>
      {meridies.map((meridiem) => {
        const timeslots = day.timeslots[meridiem];
        const isFullyBooked = !day.available && !day.hasSelectedTimeslot;

        if (isFullyBooked) {
          return (
            <Button
              key={`fully-booked-${meridiem}`}
              disabled
              style={{
                width: isMobile ? 163 : 200,
                minHeight: isMobile ? mobileCalendarCellHeight : calendarCellHeight,
                backgroundColor: '#fff',
                border: BORDERS.gray3,
                color: COLORS.gray3,
                borderRadius: ROUNDED.medium,
                fontWeight: theme.typography.fontWeightBold,
                padding: theme.spacing(2),
              }}
            >
              <Typography style={{ fontWeight: 600 }}>Fully booked</Typography>
            </Button>
          );
        }

        return timeslots.map((timeslot, timeIndex) => {
          const selectedSlot =
            selectedMeridiem === meridiem &&
            selectedTimeIndex === timeIndex &&
            timeSlotDate === timeslot?.timeslot?.date &&
            selectedDayIndex === currentDayIndex;

          const isUnavailable = !timeslot.timeslot?.available && !selectedSlot;

          return (
            <Button
              id={`timeslot-${meridiem}-${timeIndex}`}
              key={`${meridiem}-${timeIndex}`}
              disabled={isUnavailable}
              onClick={() => changeTimeslot({ day, meridiem, timeIndex })}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  changeTimeslot({ day, meridiem, timeIndex });
                }
              }}
              style={{
                minHeight: isMobile ? mobileCalendarCellHeight : calendarCellHeight,
                width: isMobile ? 163 : 200,
                padding: theme.spacing(2),
                borderRadius: ROUNDED.medium,
                fontWeight: theme.typography.fontWeightBold,
                ...(selectedSlot && {
                  color: theme.palette.primary.main,
                  backgroundColor: '#eef8ef',
                  border: `1px solid ${theme.palette.secondary.main}`,
                }),
                ...(!selectedSlot && {
                  color: theme.palette.primary.main,
                  border: BORDERS.gray3,
                }),
                ...(isUnavailable && {
                  backgroundColor: '#fff',
                  color: COLORS.gray3,
                }),
              }}
            >
              <Typography
                variant="body1"
                color={(!isUnavailable || selectedSlot) ? 'textPrimary' : undefined}
                style={{ fontWeight: 600 }}
              >
                {isUnavailable ? 'Fully booked' : parseTime(timeslot.time)}
              </Typography>
            </Button>
          );
        });
      })}
    </Box>
  );
}